<template>
  <div>
    <data-table-card
      :items="items"
      v-on:updateData="getUsers"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons v-if="userHasPerms(['Manage users'])">
        <b-button class="ml-2" :to="{ name: 'users-create' }" variant="primary">
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:cards="slotProps">

        <router-link
          :to="{ name: 'users-show', params: { id: slotProps.item.id } }"
          class="text-body pointer text-decoration-none"
        >
          <div class="row no-gutters">
            <div class="col-4 col-lg-3 p-1">
              <v-lazy-image
                v-if="slotProps.item.image"
                :src="slotProps.item.image"
                class="img-fluid maxHeight100"
              />
            </div>
            <div class="col-8 col-lg-9 p-3">
               <h5 class="font-weight-bold m-0">{{ slotProps.item.name }}</h5>
               <small class="text-muted">{{ slotProps.item.email }}</small><br><br>
               <b-badge
                class="mb-1 mr-1"
                variant="warning"
                v-for="role in slotProps.item.roles"
                :key="role.id"
                >{{ role.role }}</b-badge
              >
            </div>
          </div>
        </router-link>
      </template>
    </data-table-card>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'users' })"
      :lazy="true"
    >
      <router-view
        @userCreated="userCreated()"
        @userUpdated="userUpdated()"
      ></router-view>
    </b-modal>
  </div>
</template>

<script>
import userRepo from "@/api/repos/userRepo";
import dataTableCard from "@/components/common/DataTableCard";

export default {
  components: {
    dataTableCard: dataTableCard,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "name", label: "Name Asc", order: "asc" },
      sortOptions: [
        { column: "name", label: "Name Asc", order: "asc" },
        { column: "name", label: "Name Desc", order: "desc" },
        { column: "created_at", label: "Oldest", order: "asc" },
        { column: "created_at", label: "Newest", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getUsers({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      search: "",
    });
  },
  methods: {
    async getUsers(e) {
      this.isLoad = true;
      try {
        let { data } = await userRepo.users(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.users.data;
        this.totalRows = data.users.total;
        this.page = data.users.current_page;
        this.fromRow = data.users.from;
        this.toRow = data.users.to;
        this.lastPage = data.users.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    userCreated() {
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getUsers({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },

    userUpdated() {
      this.$bvToast.toast("User Updated", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sidebarToggle = false;
      this.getUsers({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
